export default __webpack_public_path__ + "static/media/ecesultan4.c7cd7515.jpg";